import { call, put, takeLatest } from "redux-saga/effects";
import { busTuyenDuongApi } from "../../../api/bus/busTuyenDuongApi";
import { IBaseResponeModel } from "../../../models/response/base-response";
import {
	eBusBaoCaoDiemDanhActionTypeIds,
	IBusBaoCaoDiemDanhLoadStart,
	IBusBaoCaoDiemDanhLoadTuyenDuongStart
} from "../../action-types/bus/IBusBaoCaoDiemDanhActionTypes";
import { busBaoCaoDiemDanhActions } from "../../actions/bus/busBaoCaoDiemDanhActions";

export function* busBaoCaoDiemDanhSaga(): any {
	yield takeLatest(eBusBaoCaoDiemDanhActionTypeIds.LOAD_START, loadBusBaoCaoDiemDanhWorker)
	yield takeLatest(eBusBaoCaoDiemDanhActionTypeIds.LOAD_TUYENDUONG_START, loadBusTuyenDuongWorker)
}

function* loadBusBaoCaoDiemDanhWorker(action: IBusBaoCaoDiemDanhLoadStart): any {
	const res: IBaseResponeModel = yield call([busTuyenDuongApi, busTuyenDuongApi.SelectBaoCaoDiemDanhAsync], action.payload)
	if (res.is_success) {
		yield put(busBaoCaoDiemDanhActions.loadBusBaoCaoDiemDanhSuccess(res.data || []))
	} else {
		yield put(busBaoCaoDiemDanhActions.loadBusBaoCaoDiemDanhError(res.message || "Không tải được báo cáo điểm danh xe bus"))
	}
}

function* loadBusTuyenDuongWorker(action: IBusBaoCaoDiemDanhLoadTuyenDuongStart): any {
	const res: IBaseResponeModel = yield call([busTuyenDuongApi, busTuyenDuongApi.SelectAsync], action.payload)
	if (res.is_success) {
		yield put(busBaoCaoDiemDanhActions.loadBusTuyenDuongSuccess(res.data || []))
	} else {
		yield put(busBaoCaoDiemDanhActions.loadBusTuyenDuongError(res.message || "Không tải được danh sách tuyến đường"))
	}
}
